<template>
  <div>
    <h5>Not to be used for GDPR</h5>
    <p class="mb-4">
      These details are sourced from Transunion, a credit reference agency.
      Please confirm details with the customer.
    </p>
    <div
      v-for="field in gdprFields"
      :key="field.id"
      data-testid="gdpr-field"
      class="d-flex justify-space-between align-center content-spacing mb-1"
    >
      <div>
        <template v-if="field.gdprType === 'phone1'">Phone:</template>
        {{ field.dataUpdated }}
      </div>

      <SoButton type="primary" title="Confirm" @click="submit(field)" />
    </div>
  </div>
</template>

<script lang="ts">
  import SoButton from "@/components/formControls/SoButton.vue"
  import { IGdprField } from "@/models/gdprFields/gdprFields.types"
  import { GdprFieldsService } from "@/services/GdprFieldsService"
  import { PropType } from "vue"

  export default {
    components: {
      SoButton,
    },
    props: {
      gdprFields: {
        type: Array as PropType<IGdprField[]>,
        required: true,
      },
    },
    data() {
      return {
        gdprMutator: GdprFieldsService.updateGdprFields(),
      }
    },
    methods: {
      submit(field) {
        this.gdprMutator.mutate([
          {
            id: field.id,
            confirmStatus: "CONFIRMED",
          },
        ])
      },
    },
  }
</script>
